module.exports = __webpack_public_path__ + "static/media/maquinas.c9c2b7b9.jpg";